import { useCallback, useEffect } from 'react';
import { useLoadDataRequest } from '@futrli/shared-services';
import { fetchFinancialConfig } from '../../../../core/api/financial-config';

type RequestDataType = Awaited<ReturnType<typeof fetchFinancialConfig>>;

/**
 * Loads the financial config for the given organisation ID
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 */
export const useLoadFinancialConfig = (workspaceId: string, organisationId: string) => {
  const hasAllParams = !!workspaceId && !!organisationId;
  const { load, ...rest } = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(fetchFinancialConfig(workspaceId, organisationId));
    }
  }, [hasAllParams, load, organisationId, workspaceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
